var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconAlignCenter extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#3F3F3F">
          <path
            aria-hidden="${!this.iconTitle}"
            aria-label="${ifDefined(this.iconTitle)}"
            role="${this.iconTitle && 'img'}"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.07265 1.65785C1.90345 1.72292 1.72021 1.90983 1.65423 2.08467C1.58804 2.26006 1.59788 2.52934 1.67602 2.68129C1.78973 2.90235 1.97086 3.04383 2.20304 3.09303C2.38477 3.1315 21.615 3.1315 21.7967 3.09303C22.0289 3.04383 22.21 2.90235 22.3237 2.68129C22.4018 2.52934 22.4117 2.26006 22.3455 2.08467C22.2777 1.90513 22.0963 1.72256 21.9202 1.65665C21.7902 1.608 21.7801 1.60796 11.9929 1.60921C2.29741 1.61045 2.19459 1.61096 2.07265 1.65785ZM4.66237 6.43227C4.41579 6.46827 4.17661 6.64829 4.076 6.87358C3.99567 7.05346 3.99848 7.31019 4.08272 7.48796C4.16225 7.65577 4.29586 7.78944 4.46386 7.86925L4.59586 7.93196H11.9999H19.4039L19.5359 7.86925C19.7039 7.78944 19.8375 7.65577 19.917 7.48796C20.0012 7.31019 20.0041 7.05346 19.9237 6.87358C19.819 6.63903 19.5869 6.47009 19.3154 6.43083C19.1317 6.40426 4.84462 6.40565 4.66237 6.43227ZM7.05394 11.256C6.81543 11.2968 6.61616 11.4468 6.50499 11.6693C6.44254 11.7943 6.43186 11.8425 6.43186 12C6.43186 12.3164 6.58697 12.5529 6.88676 12.6935L7.01986 12.756H11.9999H16.9799L17.113 12.6935C17.2988 12.6064 17.4096 12.5011 17.4947 12.3306C17.5572 12.2057 17.5679 12.1574 17.5679 12C17.5679 11.6835 17.4127 11.447 17.113 11.3064L16.9799 11.244L12.0719 11.2406C9.37246 11.2387 7.1144 11.2457 7.05394 11.256ZM4.61612 16.0808C4.38973 16.1259 4.18865 16.2884 4.08272 16.512C3.99848 16.6897 3.99567 16.9465 4.076 17.1263C4.18076 17.3609 4.41286 17.5298 4.68428 17.5691C4.88619 17.5983 19.1135 17.5983 19.3154 17.5691C19.4995 17.5424 19.6349 17.4759 19.7685 17.3463C20.0574 17.0659 20.0541 16.5796 19.7612 16.2867C19.7098 16.2354 19.6085 16.1652 19.5359 16.1307L19.4039 16.068L12.0599 16.0645C8.02066 16.0626 4.67098 16.0699 4.61612 16.0808ZM2.17186 20.9135C1.84743 20.9932 1.63333 21.2564 1.61353 21.6C1.60529 21.7432 1.6136 21.8076 1.65423 21.9152C1.72198 22.0948 1.90337 22.2774 2.07949 22.3433C2.20952 22.3919 2.22116 22.392 11.9999 22.392C21.7786 22.392 21.7902 22.3919 21.9202 22.3433C22.0963 22.2774 22.2777 22.0948 22.3455 21.9152C22.4117 21.7399 22.4018 21.4706 22.3237 21.3186C22.21 21.0976 22.0289 20.9561 21.7967 20.9069C21.6044 20.8662 2.33816 20.8727 2.17186 20.9135Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconAlignCenter.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconAlignCenter.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconAlignCenter.prototype, "size", void 0);
if (customElements.get('cat-icon-align-center') === undefined) {
    customElements.define('cat-icon-align-center', BlocksIconAlignCenter);
}
